const config = {
    build_number: '616352',
    build_timestamp: '2026-09-25T17:24:39.295Z',
    build_commit: '392fc1144a0b6381d36df512fefd68ee90c63127',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
